@if (!isSearching()) {
    <div class="find-me-button" id="find-me-btn" (click)="findMe.emit()">
        <warema-svg-icon
            filePath="shared-assets/icons/location.svg"
            height="20"
            role="button"
            width="14"
            [attr.aria-label]="'ARIA-LABEL-LOCATION' | translate"
        />
    </div>
} @else {
    <div class="loader-wrapper">
        <div class="loader"></div>
    </div>
}
